// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗╔═╗╔╦╗╔═╗╔═╗╔╗╔╔═╗╔╗╔╔╦╗╔═╗  ╔═╗╔═╗╦═╗╔═╗╦╦           //
//    ║  ║ ║║║║╠═╝║ ║║║║║╣ ║║║ ║ ║╣   ╠═╝║╣ ╠╦╝╠╣ ║║           //
//    ╚═╝╚═╝╩ ╩╩  ╚═╝╝╚╝╚═╝╝╚╝ ╩ ╚═╝  ╩  ╚═╝╩╚═╚  ╩╩═╝         //
//                                                             //
//*************************************************************//


import {AfterViewChecked, Component, NgZone, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import "rxjs/Rx";
import {Location} from "@angular/common";
// ITEM QUE SE DEBE MODIFICAR PARA LOS CRUD
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";
import {Rol} from "../../roles/recursos/modelo/rol";
import {Modulo} from "../../roles/recursos/modelo/modulo";
import {ConsumerService} from "../../../../recursos/servicio/consumer.service";
import {WebServices} from "../../../../recursos/modelo/consumerModel/web-services.enum";

declare var $: any;
declare var swal: any;

@Component({
    moduleId: module.id,
    selector: 'cmp-form-rol',
    templateUrl: './view/form-roles.component.html',
    styleUrls: ["./css/form-roles.component.scss"],
    providers: [ConsumerService]
})
export class FormRolComponent implements OnInit, AfterViewChecked {

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─
    roles: any[];
    modulos: Modulo[];
    // ITEM DEL CRUD
    // variables de pantalla
    origenCRUD = "Rol";
    accion = "";
    cargandoList: boolean = false;
    cargandoCombo: boolean = false;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_ROL_LISTAR: false,
        ROLE_ROL_CONSULTAR: false,
        ROLE_ROL_REGISTRAR: false,
        ROLE_ROL_MODIFICAR: false,
        ROLE_ROL_INACTIVAR: false,
        ROLE_ROL_ACTIVAR: false,
    };

    URL_BACKEND = "";
    // variables de validaciones del formulario
    form: FormGroup;
    vdl_nombre: FormControl;
    vdl_descripcion: FormControl;
    usuarioSession: any;

    //variables modelo
    ItemSelected: Rol;

    constructor(private zone: NgZone,
                private consumer: ConsumerService,
                private route: ActivatedRoute,
                private router: Router,
                private fb: FormBuilder,
                private jwtUtil: UtilConfig,
                private _location: Location) {

        // VERIFICA LOS PERMISOS DEL ROL LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        this.usuarioSession = this.jwtUtil.getCurrentUser();
        this.ItemSelected = new Rol();
        this.URL_BACKEND = this.jwtUtil.URL_WS_BACKEND;
    }

    ngOnInit() {

        this.consultarCombos();
        this.route.params.subscribe(params => {
            this.accion = "Crear";
            if (params['id']) {
                this.accion = "Consultar";
                this.realizarConsultaRol(params['id']);
            } else {
                this.cargandoList = false;
            }
            if (params["accion"]) {
                if (params["accion"] == "edit") {
                    this.accion = "Modificar";
                }
            }
        });


        this.createFormControls();
        this.createForm();
    }

    ngAfterViewChecked() {

    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴

    deshabilitarBoton(): boolean {
        return !this.form.valid;
    }
    AutorizarActualizacion() {
        if (this.form.valid) {
            swal({
                title: '¿Está seguro que desea ' + this.accion + ' el rol? ',
                text: "El rol: " + this.ItemSelected.nombre,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Si, ' + this.accion + '!'
            }).then(() => {
                this.cargandoList = true;
                this.actualizar();
            }, function (dismiss) {
                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                if (dismiss === 'cancel') {
                }
            });
        } else {
            this.cargandoList = false;
            swal({
                title: "El formulario no se encuentra válido",
                width: 600,
                html: '<p style="padding-left: 17px !important;"><b>Verificar las siguientes opciones:</b></p>' +
                    '<ol>' +
                    '<li>Los campos señalados como "Obligatorio" no se encuentran diligenciados.</li>' +
                    '<li>Los campos no presentan la longitud adecuada.</li>' +
                    '<li>Los campos no presentan el formato adecuado.</li>' +
                    '</ol>',
                type: 'error'
            });
        }
    }


    createFormControls() {
        this.vdl_nombre = new FormControl({value: "", disabled: ((this.accion == 'Consultar'))}, [
            Validators.required,
            Validators.maxLength(30)
        ]);

        this.vdl_descripcion = new FormControl({value: "", disabled: ((this.accion == 'Consultar'))}, [
            Validators.required,
            Validators.maxLength(500)
        ]);
    }


    createForm() {
        this.form = this.fb.group({
            "nombre": this.vdl_nombre,
            "descripcion": this.vdl_descripcion
        });
    }

    auditoria() {
        $("ul#slide-out").toggleClass("open");
    }

    backClicked() {
        this._location.back();
    }


    cargarFuncionalidadesRol(listaFuncionalidades) {

        $.each(this.modulos, (posM, itemM) => {
            $.each(itemM.lstFuncionalidades, (posF, itemF) => {
                itemF.check = false;
            });
        });

        $.each(listaFuncionalidades, (pos, item) => {
            $.each(this.modulos, (posM, itemM) => {
                $.each(itemM.lstFuncionalidades, (posF, itemF) => {
                    if (itemF.id == item.id) {
                        itemF.check = true;
                    }
                });
            });
        });

        $.each(this.modulos, (posM, itemM) => {
            itemM.checkAll = true;
            $.each(itemM.lstFuncionalidades, (posF, itemF) => {
                if (!itemF.check) {
                    itemM.checkAll = false;
                }
            });
        });
    }


    verificarFuncionalidad(funcionalidad, modulo) {
        funcionalidad.check = !funcionalidad.check;
        var check = true;
        $.each(modulo.lstFuncionalidades, function (pos, item) {
            if (!item.check)
                check = false;
        });

        modulo.checkAll = check;
    }


    verificarModuloFuncionalidad(modulo) {
        modulo.checkAll = !modulo.checkAll;
        $.each(modulo.lstFuncionalidades, function (pos, item) {
            item.check = modulo.checkAll;
        });
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘

    consultarCombos() {
        // LLAMADO AL SERVICIO
        this.cargandoCombo = true;
        this.consumer.post<any>(WebServices.URL_GET_COMBOS_ROLES, {})
            .subscribe(result => {

                this.modulos = [];
                $.each(result["modulos"], (pos, item) => {
                    $.each(item.funcionalidades, (posFunc, itemFunc) => {
                        itemFunc.check = false;
                    });
                    item.checkAll = false;
                    this.modulos.push(item);
                });
                this.cargarFuncionalidadesRol(this.ItemSelected.lstFuncionalidades);
                this.cargandoCombo = false;
            }, err => {
                this.cargandoCombo = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo cargar los modulos", this.router)
            });

    }

    setFuncionalidadesRol() {
        let listFuncionalidades = [];
        $.each(this.modulos, (posM, itemM) => {
            $.each(itemM.lstFuncionalidades, (posF, itemF) => {
                if (itemF.check) {
                    listFuncionalidades.push(itemF)
                }
            });

        });
        this.ItemSelected.lstFuncionalidades = listFuncionalidades;
    }

    actualizar() {
        // LLAMADO AL SERVICIO∫

        this.setFuncionalidadesRol();
        let params = {rol: this.ItemSelected};
        this.consumer.create(WebServices.URL_ACTUALIZAR_ROLES, params)
            .subscribe(result => {
                if (this.accion == "Crear") {
                    swal(
                        'Operación exitosa',
                        'Rol creado satisfactoriamente.',
                        'success'
                    );
                } else {
                    swal(
                        'Operación exitosa',
                        'Rol modificado satisfactoriamente.',
                        'success'
                    );
                }
                this.router.navigate(['/content', {outlets: {'second': ['roles']}}]);
                this.cargandoList = false;
            }, err => {
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo " + this.accion + " el rol", this.router)
            });


    }

    private realizarConsultaRol(id) {
        // LLAMADO AL SERVICIO
        this.cargandoList = true;
        this.consumer.getById<any>("rol", id, WebServices.URL_GET_ROLES)
            .subscribe((result) => {
                this.ItemSelected = result["rol"];
                this.cargarFuncionalidadesRol(this.ItemSelected.lstFuncionalidades);
                this.cargandoList = false;
            }, err => {
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo consultar el rol", this.router)
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/roles/cmp-form-roles/form-roles.component.ts